import { useState, useEffect } from "react";
import { Grid } from "antd";
/* 引入 antd 自訂義布局(layout) 
   useBreakpoint : 觀測使用者瀏覽視窗 回傳 boolean 值
    xs：瀏覽寬度 小於 576px。通常代表較小的移動設備，如手機。
    sm：瀏覽寬度 大於等於 576px。這可能是小型平板電腦或大部分的手機設備。
    md：瀏覽寬度 大於等於 768px。通常代表中等大小的平板電腦或螢幕較寬的手機。
    lg：瀏覽寬度 大於等於 992px。這可能是桌面電腦或較大的平板電腦。
    xl：瀏覽寬度 大於等於 1200px。較大的桌面電腦螢幕。
    xxl：瀏覽寬度 大於等於 1600px。這是非常大的桌面電腦螢幕。*/

const { useBreakpoint } = Grid;

export const useMDCollapse = () => {
  // 使用 useBreakpoint Hook 檢測螢幕尺寸
  const screens = useBreakpoint();
  
  // 從 screens 物件中取得 xs 尺寸的布林值，表示是否處於 < 576px 的小螢幕尺寸下
  const isMD = screens.xs;
  // 使用 useState 創建一個折疊狀態變數 isCollapse，初始值為 isMD（如果是 undefined 則為 false）
  const [isCollapse, setIsCollapse] = useState(isMD ?? false);
  
  // useEffect 監聽 isMD 變化
  useEffect(() => {
    // 如果 isMD 為 true，表示處於小螢幕尺寸下，設置折疊狀態為已折疊（true）
    if (isMD) {
      setIsCollapse(true);
    } else {
      // 否則，設置折疊狀態為未折疊（false）
      setIsCollapse(false);
    }
  }, [isMD]);
  // 返回一個物件，包含折疊狀態、設置折疊狀態的函式和是否處於小螢幕尺寸下的布林值
  return { isCollapse, setIsCollapse, isMD };
};
